import Box from '@mui/material/Box';

import { styled } from 'helpers';

const Container = styled(Box)<{ fullWidth: boolean }>`
  display: inline-flex;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
`;

const CalendarContainer = styled(Box)`
  box-shadow: 0px 2px 16px rgba(34, 38, 72, 0.3);
  border-radius: 8px;
  outline: 0;
  width: 330px;

  & .MuiPickerStaticWrapper-root {
    border-radius: 8px;
  }
  & .MuiButtonBase-root-MuiIconButton-root:hover {
    background: none;
  }
  & .MuiButtonBase-root-MuiIconButton-root.MuiIconButton-edgeStart:hover {
    background-color: ${({ theme }) => theme.palette.grey['A50']};
  }

  &
    .MuiCalendarPicker-viewTransitionContainer
    .PrivatePickersSlideTransition-root
    .MuiPickersDay-root.MuiPickersDay-dayWithMargin.MuiPickersDay-today:hover {
    background-color: ${({ theme }) => theme.palette.grey['A100']};
  }
  &
    .MuiCalendarPicker-viewTransitionContainer
    .PrivatePickersSlideTransition-root
    .MuiPickersDay-root.MuiPickersDay-dayWithMargin:hover {
    background: none;
  }

  & .MuiButtonBase-root.MuiPickersDay-today {
    background: ${({ theme }) => theme.palette.grey['A100']};
    border-radius: 40px;
    border: none;
  }
  & .PrivatePickersYear-yearButton {
    color: ${({ theme }) => theme.palette.blueGrey['900']};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  }
  & .PrivatePickersYear-yearButton:hover {
    background-color: ${({ theme }) => theme.palette.grey['A50']};
  }
  & .PrivatePickersYear-yearButton.Mui-selected {
    background: ${({ theme }) => theme.palette.blue['A50']};
    color: ${({ theme }) => theme.palette.blue['800']};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    border: 2px solid ${({ theme }) => theme.palette.blue['800']};
  }
  & .PrivatePickersYear-yearButton.Mui-selected:hover {
    background: ${({ theme }) => theme.palette.blue['50']};
  }
`;

export { Container, CalendarContainer };
